<template>
  <Hero :title="$t('message.hero.reviewResponse')"></Hero>
</template>

<script>
import Hero from '../../Hero.vue';

export default {
  name: 'ReviewYourResponses',
  components: {
    Hero,
  },
};
</script>

<style scoped></style>
